module.exports = __webpack_public_path__ + "static/media/transactions-fr.db3a87e8.png";